// server.autosuggest.js
import React from 'react';
import { useState, useEffect, useCallback } from "react";
import AutoSuggest from "react-autosuggest";
import httpClient from '../../../services/httpClient'
import theme from './LawFirmAutoSuggest.module.css';
import Address from "../address/Address";

const LawFirmAutoSuggest = ({ setLawFirm, selectedOfficeId, loggedInLawFirmName, userName, setSearchId }) => {
    const [searchValue, setSearchValue] = useState("");
    const [suggestions, setSuggestions] = useState([]);
    const [match, setMatch] = useState("");
    const [isTyping, setIsTyping] = useState(false);
    const [timer, setTimer] = useState(null);

    const getSuggestionsAsync = useCallback(async (value) => {
        let response = {
            "lawFirms": [],
            "errors": [],
            "searchId": null
        }
        try {
            const inputValue = value.trim().toLowerCase();
            if (inputValue.length >= 3) {
                const domain = window.location.host;
                let configs = require('../../../config.json');
                const config = configs.filter(c => c.Domain.toLowerCase() === domain.toLowerCase())[0];
                httpClient.defaults.headers.common['Users-Law-Firm'] = loggedInLawFirmName;
                httpClient.defaults.headers.common['Username'] = userName;
                httpClient.defaults.headers.common['Office-Id'] = selectedOfficeId ?? -1;
                response =
                    await httpClient.get(config.FunctionAppUrl + "/lawfirms?q=" + encodeURIComponent(inputValue));
                if (response.errors.length >= 1) {
                    setMatch(response.errors[0]);
                } else {
                    setMatch('');
                }
            } else {
                setMatch('');
            }
        } catch (error) {
            setMatch(
                'Something went wrong, please try again. If you continue to experience the same issues, please contact the team on 0343 221 0610');
            if (error != null && error.response != null && error.response.errors != null) {
                if (error.response.errors.length >= 1) {
                    setMatch(error.response.errors[0]);
                }
            }
        }

        return response;
    }, [loggedInLawFirmName, selectedOfficeId, userName]);

    const getLawFirmName = suggestion => {
        let lawfirmName;
        if (suggestion ?? false) {
            //use trading name as the default if both trading name and registered company name are the same
            if (suggestion.tradingName?.trim().toUpperCase() === suggestion.companyName?.trim().toUpperCase()) {
                lawfirmName = suggestion.tradingName;
            } else {
                //the name needs to match the format Trading Name (Registered Name)
                var registeredCompanyName = suggestion.companyName;
                var registeredCompanyNameWithBrackets = " (" + suggestion.companyName + ")";
                lawfirmName = (suggestion.tradingName ?? "").trim() === "" ? registeredCompanyName : suggestion.tradingName + registeredCompanyNameWithBrackets;
            }
        }
        return lawfirmName;
    };

    useEffect(() =>
        isTyping === false && searchValue.length >= 3 ?
            getSuggestionsAsync(searchValue).then(result => {
                setSuggestions(result.lawFirms ?? [])
                setSearchId(result.searchId)
            }) :
            setSuggestions([]),
        [isTyping, searchValue, getSuggestionsAsync]);

    const renderSuggestion = suggestion => (
        <span className="sugg-option">
            <span className="name">
                {getLawFirmName(suggestion)}, <Address lawFirm={suggestion} />
            </span>
        </span>
    );

    const getSuggestionValue = suggestion => {
        setLawFirm(suggestion);  
        return suggestion.companyName;
    };

    const onSuggestionsClearRequested = () => setSuggestions([]);

    const onSuggestionsFetchRequested = ({ value }) => { 
        clearTimeout(timer);
        setIsTyping(true);
        setSearchValue(value);
        setTimer(setTimeout(() => setIsTyping(false), 600));
    };

    const onSuggestionSelected = () => { 
        setSearchValue("");
        setSuggestions([]);   
    };

    const inputProps = {
        placeholder: 'Start typing company name or postcode (min 3 characters)...',
        value: searchValue,
        onChange: (_, { newValue }) => {
            setSearchValue(newValue);
        }
    };

    return (
        <span data-testid="law-firm-auto-suggest">
            <AutoSuggest
                theme={theme}
                suggestions={suggestions}
                onSuggestionsClearRequested={onSuggestionsClearRequested}
                onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                onSuggestionSelected={onSuggestionSelected}
                getSuggestionValue={getSuggestionValue}
                renderSuggestion={renderSuggestion}
                inputProps={inputProps}
            />
            <span id="search-result" className="text-danger"> { match } &nbsp;</span>
        </span>
    );

}

export default LawFirmAutoSuggest;